var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/** Build step-interpolated polyline points from data values. */
export function stepPoints(data, toXY) {
    var pts = [];
    for (var i = 0; i < data.length; i++) {
        var _a = __read(toXY(i, data[i]), 2), x = _a[0], y = _a[1];
        if (i === 0) {
            pts.push(x, y);
        }
        else {
            pts.push(x, data[i - 1] !== undefined ? toXY(i - 1, data[i - 1])[1] : y);
            pts.push(x, y);
        }
    }
    return pts;
}
/** Catmull-Rom spline through points [[x,y],...] */
export function catmullRomPath(points, tension) {
    if (tension === void 0) { tension = 0.5; }
    if (points.length < 2)
        return '';
    if (points.length === 2) {
        return "M ".concat(points[0][0], " ").concat(points[0][1], " L ").concat(points[1][0], " ").concat(points[1][1]);
    }
    var d = "M ".concat(points[0][0], " ").concat(points[0][1]);
    for (var i = 0; i < points.length - 1; i++) {
        var p0 = points[Math.max(i - 1, 0)];
        var p1 = points[i];
        var p2 = points[i + 1];
        var p3 = points[Math.min(i + 2, points.length - 1)];
        var cp1x = p1[0] + ((p2[0] - p0[0]) / 6) * tension;
        var cp1y = p1[1] + ((p2[1] - p0[1]) / 6) * tension;
        var cp2x = p2[0] - ((p3[0] - p1[0]) / 6) * tension;
        var cp2y = p2[1] - ((p3[1] - p1[1]) / 6) * tension;
        d += " C ".concat(cp1x, " ").concat(cp1y, " ").concat(cp2x, " ").concat(cp2y, " ").concat(p2[0], " ").concat(p2[1]);
    }
    return d;
}
export function pointsToPairs(points) {
    var pairs = [];
    for (var i = 0; i < points.length; i += 2) {
        pairs.push([points[i], points[i + 1]]);
    }
    return pairs;
}
